import { getFilterState } from "./filterQueryString";
import { IReduxState } from "./reducers.interfaces";

export const defaults: IReduxState = {
    isLoading: true,
    products: [],
    filters: getFilterState(),
    sortMethod: null,
    focusedProductID: null,
    optionValues: {},
    quantity: 1,
};
